var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeAboutIcon3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8_350",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 70,
    height: 70
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H69.6729V70H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8_350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.155 58.3789H68.3121V46.317L60.9638 33.4388H48.0809",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4662 60.5597C63.4662 62.9796 61.5136 64.9414 59.105 64.9414C56.6964 64.9414 54.7438 62.9796 54.7438 60.5597C54.7438 58.1398 56.6964 56.178 59.105 56.178C61.5136 56.178 63.4662 58.1398 63.4662 60.5597Z",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4887 60.5597C23.4887 62.9796 21.5361 64.9414 19.1275 64.9414C16.7188 64.9414 14.7662 62.9796 14.7662 60.5597C14.7662 58.1398 16.7188 56.178 19.1275 56.178C21.5361 56.178 23.4887 58.1398 23.4887 60.5597Z",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1672 22.3519H48.081V58.3789H23.4886",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0724 58.3789H8.70898V34.7266",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1946 50.5892H8.70911",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1761 58.3789H48.0811",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0628 50.214H65.985",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6317 46.3171H54.1598V33.4388",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4332 37.3242C26.3015 37.3242 33.4906 30.1014 33.4906 21.1914C33.4906 12.2814 26.3015 5.05859 17.4332 5.05859C8.56483 5.05859 1.37573 12.2814 1.37573 21.1914C1.37573 30.1014 8.56483 37.3242 17.4332 37.3242Z",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.42 32.6519V31.6589",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4462 9.73101V10.724",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02625 21.1783H7.01459",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8065 21.1914H17.4331V16.8131",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeAboutIcon3);
export default __webpack_public_path__ + "static/media/home-about-icon-3.850c532eaea47cc9c32d8bc8c2a59965.svg";
export { ForwardRef as ReactComponent };